import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import { logUserIn } from '../actions/AuthActions'

const mapStateToProps = state => ({
  invalid: state.auth.invalid,
  authenticated: state.auth.session.token !== false
})

const mapDispatchToProps = dispatch => ({
  logInAction: (login, password) => dispatch(logUserIn(login, password))
})

class LoginFormComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: '',
      password: ''
    }
  }

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { login, password } = this.state
    this.props.logInAction(login, password)
  }

  render() {
    const { authenticated, invalid } = this.props
    if (authenticated) return <Redirect to='/' />
    const { login, password } = this.state

    return (
      <div className="login-stage">
        <form className="login-card" onSubmit={this.handleSubmit}>
          <h3>Zaloguj się</h3>
          <div className="field">
            <label>LOGIN</label>
            <input type="text" value={login} onChange={this.handleChange('login')} autoComplete="off" required />
          </div>
          <div className="field">
            <label>HASŁO</label>
            <input type="password" value={password} onChange={this.handleChange('password')} required />
          </div>
          <button type="submit" className="block">Zaloguj się</button>
          {invalid && <p className="form-error">Nieprawidłowy login lub hasło.</p>}
        </form>
      </div>
    )
  }
}

const LoginForm = connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent)
export default withRouter(LoginForm)
